module.exports = __webpack_public_path__ + "media/meditation_1.84ef3aaf.mp4";